export const environment = {
  production: true,
  name: "FANTASY SHELTER",
  stripe:{
    publishableKey: 'pk_live_51MbqQ1Ani8EG3XnL3fkc9ugtzJO0fWQV4hWHWJZsWpZSUx5E9uyp2i9sxsRpOKTLM7bXdDoD5Rl9E8FjNUVznijv00HjmrFUbq',
    secretKey: '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'
  },
  api : 'https://back.fantasyshelter.com/api/',
  api_key: "S4zEvIGrTTT3b3xvBVM9tXvwwVG851TazwaVssHAwzwq29AHqJ0KFd2p1ie8iySOY1wa0OFOQ3Ea0i518qRYRz15wx8YMvzZOFbP7pC"
};

export const url = 'https://back.fantasyshelter.com/api';
export const web = 'https://back.fantasyshelter.com';



// export const environment = {
//   production: false,
//   stripe:{
//     publishableKey: 'pk_test_51MbqQ1Ani8EG3XnLmIYvWIR7TiyRwIAZMuwGnHMj1Rg36hDzZlgq70UmsToAfYiLyhQERzbhhaAAw455xOPhMYeB00ckZYwHvl',
//     secretKey: 'sk_test_51MbqQ1Ani8EG3XnLloEm0DQRDiEKW3GKeFGNFnin0mpL2f7RVOchZuWKGUpLV7oFi2CyWataIev0oa9yJvnVLdFU00EERfO7fo'
//   },
//   api : 'https://fs-back.ravendt.net/api/',
//   api_key: "S4zEvIGrTTT3b3xvBVM9tXvwwVG851TazwaVssHAwzwq29AHqJ0KFd2p1ie8iySOY1wa0OFOQ3Ea0i518qRYRz15wx8YMvzZOFbP7pC"
// };

// export const url = 'https://fs-back.ravendt.net/api';
// export const web = 'https://fs-back.ravendt.net';
